import React, { Dispatch, useContext, useReducer } from "react";

import { User } from "../models/user";
import { IUserAction, nullUser, userReducer } from "./reducers/userReducer";

//#region create Context
interface UserContextObj {
  user: User;
  dispatchUser: Dispatch<IUserAction>;
}

const UserContext = React.createContext<UserContextObj | null>(null);
//#endregion

//#region useContext Hook
export const useUserContext = () => {
  const context = useContext(UserContext);

  if (!context)
    throw new Error("UserContext must be placed within UserProvider");

  return context;
};
//#endregion

type UserContextProviderProps = {
  children: React.ReactNode;
};

const UserContextProvider = (props: UserContextProviderProps) => {
  const { children } = props;

  const [user, dispatchUser] = useReducer(userReducer, nullUser);

  const value = { user, dispatchUser };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export { UserContext, UserContextProvider };
